<template>
  <header id="landing__masthead" class="masthead">
      <div class="container">
        <div class="masthead-text" v-scroll-reveal>
          <h1 class="masthead-heading">ARCTEC WELDING</h1>
          <h2 class="masthead-sub-heading">Welding Products for Welding Professionals</h2>
          <button class="btn btn-primary btn-lg" v-scroll-to="'#landing__introduction'">Tell Me More</button>
        </div>
      </div>
  </header>
</template>
<script>
export default {};
</script>
<style lang="scss">
header.masthead {
  text-align: center;
  background-image: url("../../assets/img/welding.jpg");
  background-repeat: no-repeat;
  background-attachment: scroll;
  background-position: center center;
  background-size: cover;

  .row {
    height: 100%;
    z-index: 2;
    background: rgba(0, 0, 0, 0.5);
  }

  .masthead-text {
    padding-top: 150px;
    padding-bottom: 100px;

    .masthead-heading {
      font-size: 4rem;
      font-weight: 500;
      line-height: 1em;
      margin-bottom: 0.66em;
      color: white;
      // font-family: "Montserrat", -apple-system, BlinkMacSystemFont, "Segoe UI",
      //   Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji",
      //   "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    }

    .masthead-sub-heading {
      font-size: 2rem;
      line-height: 1em;
      margin-bottom: 0.66em;
      color: white;
      // font-family: "Droid Serif", -apple-system, BlinkMacSystemFont, "Segoe UI",
      //   Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji",
      //   "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    }
  }
}

@media (min-width: 768px) {
  header.masthead .masthead-text {
    padding-top: 300px;
    padding-bottom: 200px;

    .masthead-heading {
      font-size: 5rem;
      font-weight: 700;
      // font-family: "Montserrat", -apple-system, BlinkMacSystemFont, "Segoe UI",
      //   Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji",
      //   "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    }

    .masthead-sub-heading {
      font-size: 2.5rem;
      // font-family: "Droid Serif", -apple-system, BlinkMacSystemFont, "Segoe UI",
      //   Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji",
      //   "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    }
  }
}
</style>